/**
 * 連携設定ハブページ
 *
 * 外部サービスへの遷移ボタンを表示する
 */

import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router'

import { Header } from '@/components/shared/header'
import { useGoBack } from '@/hooks/useGoBack'
import { PATHS } from '@/routes/paths'

export const SettingsIntegrationsPage = () => {
  const goBack = useGoBack()
  return (
    <div className="flex h-dvh flex-col bg-background">
      <Header title="連携設定" onClose={goBack} />
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        <Link
          to={PATHS.SETTINGS.EUFY}
          className="flex items-center justify-between rounded-lg border bg-card p-4 transition-colors hover:bg-accent/50"
        >
          <div className="flex items-center gap-3">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-green-500/15">
              <span className="text-lg">⚖️</span>
            </div>
            <div>
              <p className="font-medium">Eufy 体重計</p>
              <p className="text-xs text-muted-foreground">体重・体組成データの同期</p>
            </div>
          </div>
          <ChevronRight size={20} className="text-muted-foreground" />
        </Link>

        <Link
          to={PATHS.SETTINGS.HA}
          className="flex items-center justify-between rounded-lg border bg-card p-4 transition-colors hover:bg-accent/50"
        >
          <div className="flex items-center gap-3">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-teal-500/15">
              <span className="text-lg">🏠</span>
            </div>
            <div>
              <p className="font-medium">Home Assistant</p>
              <p className="text-xs text-muted-foreground">デバイスマッピング・ヘルスデータ連携</p>
            </div>
          </div>
          <ChevronRight size={20} className="text-muted-foreground" />
        </Link>

        <Link
          to={PATHS.SETTINGS.API_USAGE}
          className="flex items-center justify-between rounded-lg border bg-card p-4 transition-colors hover:bg-accent/50"
        >
          <div className="flex items-center gap-3">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-blue-500/15">
              <span className="text-lg">📊</span>
            </div>
            <div>
              <p className="font-medium">API 消費量</p>
              <p className="text-xs text-muted-foreground">Google API の無料枠の使用状況</p>
            </div>
          </div>
          <ChevronRight size={20} className="text-muted-foreground" />
        </Link>

        <Link
          to={PATHS.SETTINGS.AI_USAGES}
          className="flex items-center justify-between rounded-lg border bg-card p-4 transition-colors hover:bg-accent/50"
        >
          <div className="flex items-center gap-3">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-violet-500/15">
              <span className="text-lg">🤖</span>
            </div>
            <div>
              <p className="font-medium">AI の利用箇所</p>
              <p className="text-xs text-muted-foreground">機能ごとの Gemini のモデル・無料枠・プロンプト</p>
            </div>
          </div>
          <ChevronRight size={20} className="text-muted-foreground" />
        </Link>
      </div>
    </div>
  )
}
